var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Cascader',{staticClass:"inptext",attrs:{"data":_vm.areadata,"placeholder":"请选择省市区","change-on-select":""},model:{value:(_vm.areaid),callback:function ($$v) {_vm.areaid=$$v},expression:"areaid"}})}
var staticRenderFns = []

export { render, staticRenderFns }